import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminGuard({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;

    async function verify() {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) {
          if (active) setStatus('login');
          return;
        }

        const response = await fetch('/api/admin/me', {
          headers: { Authorization: `Bearer ${session.access_token}` },
          cache: 'no-store'
        });

        if (active) {
          setStatus(response.ok ? 'allowed' :
            response.status === 401 ? 'login' :
            response.status === 403 ? 'denied' : 'error');
        }
      } catch {
        if (active) setStatus('error');
      }
    }

    verify();
    return () => { active = false; };
  }, []);

  if (status === 'login') return <Navigate to="/login" replace />;
  if (status === 'denied') return <Navigate to="/dashboard" replace />;
  if (status === 'loading') return <div className="p-6">Verificando acceso...</div>;
  if (status === 'error') return <div className="p-6">No fue posible verificar el acceso.</div>;

  return children;
}
